import {
    CURRENCIES_FETCH,
    CURRENCIES_FETCH_ALL,
    CURRENCIES_CONVERSION,
    CURRENCIES_IS_FETCING,
    CURRENCY_FILTER,
    CURRENCY_EDIT,
} from 'constants/currencies'

export default function currenciesReducer(state = {
    list: [],
    pageable: {
        sort: {
            'currencyId': false,
            'name': 'asc',
            'description': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case CURRENCIES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case CURRENCIES_FETCH_ALL:
            return {
                ...state,
                list: action.payload,
            }
        case CURRENCIES_CONVERSION:
            return {
                ...state,
                conversionData: action.payload,
            }
        case CURRENCY_EDIT:
            return {
                ...state,
            }
        case CURRENCIES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case CURRENCY_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/currencies.js